var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calm-FileUpload",on:{"click":_vm.selectFile}},[_vm._t("default"),_c('input',_vm._b({key:_vm.key,ref:"file",style:({
            display: 'none'
        }),attrs:{"type":"file","accept":_vm.accept,"disabled":_vm.disabled},on:{"change":_vm.change}},'input',_vm.attrs,false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }